import { useState, useRef, useEffect } from 'react';
import * as S from './style';
import { Checkbox } from '../Checkbox';

const MultiSelectDropdown = ({ items, label, selectedItems, setSelectedItems, placeholder }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  
  const dropdownRef = useRef(null);

  const handleCheckboxChange = (item) => {
    const itemExists = selectedItems.some((i) => i.label === item.label);

    setSelectedItems((prevSelectedItems) =>
      itemExists
        ? prevSelectedItems.filter((i) => i.label !== item.label)
        : [...prevSelectedItems, item]
    );
  };

  const handleCloseIconClick = (item) => {
    handleCheckboxChange(item);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div style={{ position: 'relative' }}>
      <S.MultiSelectDropdownLabel>
        {label}
      </S.MultiSelectDropdownLabel>
      <S.DropdownContainer ref={dropdownRef} onClick={() => setShowDropdown(!showDropdown)} show={showDropdown}>
        <S.SelectedItemsWrapper>
          <S.SelectedList>
            {selectedItems.length === 0 ? (
              <S.SelectPlaceholder>{ placeholder }</S.SelectPlaceholder>
            ) : (
              selectedItems.map((item) => (
                <S.SelectedItem key={item.label}>
                  {item.label}
                  <S.CloseIcon onClick={() => handleCloseIconClick(item)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M15 5L5 15M5 5L15 15" stroke="#A19CAF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </S.CloseIcon>
                </S.SelectedItem>
              ))
            )}
          </S.SelectedList>
        </S.SelectedItemsWrapper>
      </S.DropdownContainer>
      <S.DropdownList show={showDropdown}>
        <S.DropdownListContent show={showDropdown}>
          {items.map((item) => (
            <S.Item key={item.label}>
              <Checkbox
                id={item.label}
                value={selectedItems.some((i) => i.label === item.label)}
                onChange={() => handleCheckboxChange(item)}
                name="confirmDownload"
                label={item.label}
                style={{ cursor: 'pointer', minHeight: 'auto' }}
              />
            </S.Item>

          ))}
        </S.DropdownListContent>
      </S.DropdownList>
    </div>
  );
};

export default MultiSelectDropdown;